import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-modal-falha-login',
  templateUrl: './modal-falha-login.component.html',
  styleUrls: ['./modal-falha-login.component.scss']
})
export class ModalFalhaLoginComponent implements OnInit {

  @Input() data: any;
  @ViewChild("card", null)

  public card: ElementRef;
  public customLogin = null;
  public modalDanger = false;
  public modalSuccess = false;

  constructor(
    protected ref: NbDialogRef<ModalFalhaLoginComponent>
  ) { }

  ngOnInit() {
    this.card.nativeElement.ownerDocument.activeElement.blur();
    this.data = this.data || [];
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
  }

  getColorNotification() {
    if (this.data.titulo === 'Conta bloqueada temporariamente') {
      this.modalDanger = true;
      return '#ffecec';
    }
    if (this.data.subtitulo === 'Sucesso') {
      this.modalSuccess = true;
      return '#d3f0d4';
    }
    return '#fff6e2';
  }

  close() {
    this.ref.close();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

}
